import { capitalize } from 'Data/format.js'
export function populateTemplate(questions, template, values) {
  if (!template) return template

  let re = /\{\{(.+?)\}\}/gim
  let output = template

  try {
    let t = [...template.matchAll(re)]
    t.forEach(item => {
      output = output.replaceAll(
        item[0],
        capitalize(
          values[item[1]] ||
            values[
              questions.find(question => question?.resource_id === item[1])?.id
            ]
        )
      )
    })
  } catch (_) {}

  return output
}
